import { getLocale } from "../runtime";

const sv_rocountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Rumänien`
};

const rocountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_rocountry(inputs)
	return "roCountry";
};

export { rocountry as "roCountry" };